import { ReactElement } from 'react';
import { ReactComponent as ResearchIcon } from '../../../../assets/img/research.svg';
import { SelectClientContainer } from './styles';
import { useTranslation } from 'react-i18next';

export function ClientSelectionInfo(): ReactElement {
  const { t } = useTranslation();

  return (
    <SelectClientContainer>
      <div>
        <ResearchIcon />
        <h3>{t('selecioneUmClienteApresentarInformacoes')}</h3>
        <p>{t('podemosApresentarInformacoesDeUmCliente')}</p>
      </div>
    </SelectClientContainer>
  );
}
